import { render, staticRenderFns } from "./Punschfest2024.vue?vue&type=template&id=4c6d6cae&scoped=true"
import script from "./Punschfest2024.vue?vue&type=script&lang=js"
export * from "./Punschfest2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d6cae",
  null
  
)

export default component.exports